import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../lib/api';
import type { PagedResult, PersonSearchResultDto, QueryOptions } from '../lib/types';

export interface PeopleSearchOptions extends QueryOptions {
  office?: string;
  serviceLine?: string;
}

/**
 * People-only search for the saved-filter picker. `filter` (from QueryOptions) is sent as
 * `q` — a name substring. `office`/`serviceLine` narrow to people who have an assignment on
 * a matching project (people have no intrinsic office/service line).
 */
export function usePeopleSearch(options: PeopleSearchOptions) {
  const params = new URLSearchParams();
  if (options.filter) params.set('q', options.filter);
  if (options.office) params.set('office', options.office);
  if (options.serviceLine) params.set('serviceLine', options.serviceLine);
  if (options.page) params.set('page', String(options.page));
  if (options.pageSize) params.set('pageSize', String(options.pageSize));
  if (options.sortBy) params.set('sortBy', options.sortBy);
  if (options.sortDesc != null) params.set('sortDesc', String(options.sortDesc));

  return useQuery({
    queryKey: ['people-search', options],
    queryFn: () => apiClient.get<PagedResult<PersonSearchResultDto>>(`/api/people/search?${params}`),
  });
}
